import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../../Config/AxiosInstance";
import APILIST from "../../../Config/ApiList";

export const GET_INCOMPLETE_JOB = createAsyncThunk("incomplete/job/get", async ({page, pageSize}) => {
    try {
        const response = await AxiosInstance.get(APILIST.GET_INCOMPLETE_JOB, {
            params: {
                page: page,
                page_size: pageSize,
            }

        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
})
export const GET_INCOMPLETE_JOB_BY_ID = createAsyncThunk("incomplete/job/get-by-id", async (id) => {
    try {
        const response = await AxiosInstance.get(APILIST.GET_BY_ID_JOB_INCOMPLETE, {
            params: {
                job_id: id
            }
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
})